import { ROUTES } from '@klokhuis/core/Routing';
import { NavLink } from '@klokhuis/core/Routing/NavLink';

import styles from './LogoLink.module.css';

const TheBudgetPropertiesLogo: React.FC = () => {
  return (
    <div
      style={{
        fontFamily: "'Poppins', sans-serif",
        fontWeight: 400,
        fontSize: '24px',
        lineHeight: '24px',
        letterSpacing: '0.18px',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <span style={{ color: '#111' }}>find</span>

      <span
        style={{
          backgroundColor: 'var(--design-color-primary-main)',
          color: '#fff',
          padding: '4px 12px',
          borderRadius: '999px',
          margin: '0 3px',
          fontWeight: 800,
          fontSize: '1em', // 👈 bigger than rest
          lineHeight: 1,
        }}
      >
        my
      </span>

      <span style={{ color: '#111' }}>props</span>

      <span
        style={{
          color: '#777',
          fontSize: '0.9rem',
          marginLeft: '6px',
          fontWeight: 500,
        }}
      >
        .com
      </span>
    </div>
  );
};

export default TheBudgetPropertiesLogo;

export const LogoLink = () => {
  return (
    <NavLink.Anchor
      href={ROUTES.Home.url({})}
      underline="none"
      className={styles.root}
    >
      <TheBudgetPropertiesLogo />
    </NavLink.Anchor>
  );
};
